import { InsertLinksHost } from 'owa-attachment-link-common';
import { lazyShowInsertLinkDialog } from 'owa-compose-ribbon';
import { owaDate } from 'owa-datetime';
import { InsertLinkSource } from 'owa-editor-ribbonplugin';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { isMac } from 'owa-user-agent/lib/userAgent';
import { ContentEditFeature, IEditor } from 'roosterjs-editor-types';

const KEY_K = 75;

const hasCtrlOrMetaKey: (event: KeyboardEvent) => boolean = isMac()
    ? e => e.metaKey
    : e => e.ctrlKey;

export function handleInsertLinkShortcut(
    editor: IEditor,
    editorViewState: EditorViewState,
    fromAddress: string,
    insertLinksHost: InsertLinksHost
): ContentEditFeature {
    return {
        keys: [KEY_K],
        allowFunctionKeys: true,
        shouldHandleEvent: event => {
            const rawEvent = event.rawEvent;
            return !rawEvent.altKey && !rawEvent.shiftKey && hasCtrlOrMetaKey(rawEvent);
        },
        handleEvent: event => {
            const rawEvent = event.rawEvent;
            rawEvent.preventDefault();
            rawEvent.stopPropagation();
            lazyShowInsertLinkDialog
                .import()
                .then(showInsertLinkDialog =>
                    showInsertLinkDialog(
                        editorViewState,
                        editor.getDocument().defaultView,
                        InsertLinkSource.ShortKey,
                        owaDate(),
                        fromAddress,
                        insertLinksHost
                    )
                );
        },
    };
}
